import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
const withReduxForm = BaseComponent => class extends Component {
  static propTypes = {
    form: PropTypes.string.isRequired,
    validate: PropTypes.func.isRequired,
  }

  WrappedComponent = reduxForm({
    form: this.props.form,
    validate: this.props.validate,
    enableReinitialize: true,
  })(BaseComponent);

  render() {
    const WrappedComponent = this.WrappedComponent;
    return <WrappedComponent {...this.props} />;
  }
};

export default withReduxForm;
